import React from 'react';
import moment from 'moment';

const ChangeLogsTable = ({
    rows,
    paginationData,
    paginationState,
    setPaginationState,
}: {
    rows?: any;
    paginationData?: any;
    paginationState?: any;
    setPaginationState?: any
}) => {

    return (
        <div className=''>
            <div className='overflow-x-auto max-h-[520px] overflow-y-auto border border-1 !rounded-xl dark:border-borderColor-darkMode'>
                <table className='min-w-full bg-white dark:bg-black dark:text-primary-dark'>
                    <thead className='bg-white dark:bg-black text-left text-sm font-medium text-black dark:text-primary-dark rounded-xl'>
                        <tr>
                            <th className='px-4 py-3'>Timestamp</th>
                            <th className='px-4 py-3'>User</th>
                            <th className='px-4 py-3'>Template Name</th>
                            <th className='px-4 py-3'>Rule Name</th>
                            <th className='px-4 py-3'>Old Value</th>
                            <th className='px-4 py-3'>New Value</th>
                            <th className='px-4 py-3'>Reason/Note</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(rows && rows?.length > 0) && rows?.map((row: any) => (
                            <tr key={row.id} className='hover:bg-gray-50 dark:hover:bg-bgColor-darkMode text-sm'>
                                <td className={`px-4 py-4`}>{moment(row?.timestamp).format('DD-MM-YYYY, hh:mm A')}</td>
                                <td className={`px-4 py-4`}>{row?.user?.name || row?.user?.email}</td>
                                <td className={`px-4 py-4`}>{row?.templateName || '--'}</td>
                                <td className={`px-4 py-4`}>{row?.ruleName || '--'}</td>
                                <td className={`px-4 py-4 text-[#EF4444]`}>{row?.oldValue}</td>
                                <td className={`px-4 py-4 text-[#10B981]`}>{row?.newValue}</td>
                                <td className={`px-4 py-4`}>{row?.reasonNote || '--'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ChangeLogsTable;
